import { useSearchParams } from "react-router-dom";
import { AiScriptSpreadsheetViewer } from "@/payroll/ai-script/ai-script-spreadsheet-viewer";
import type { AiScriptChatSelectionContext } from "@/payroll/ai-script/types";
import { workbookPath } from "./utils";
/**
 * The generated workbook, read only. `readOnlySource` points the shared payroll
 * viewer at the report endpoints and turns off everything payroll-specific:
 * editing, scoped reruns, operation recovery and sheet prefetch.
 */
export const ReportWorkbook = ({
  businessId,
  runId,
  onAskAiAboutCell,
}: {
  businessId: string;
  runId: string;
  onAskAiAboutCell?: (context: AiScriptChatSelectionContext) => void;
}) => {
  const [params, setParams] = useSearchParams();
  return (
    <AiScriptSpreadsheetViewer
      businessId={businessId}
      runId={runId}
      onAskAiAboutCell={onAskAiAboutCell}
      fillHeight
      readOnlySource={{
        cacheKey: "profitability-workbook",
        workbookPath: workbookPath(businessId, runId),
      }}
      activeSheetId={params.get("sheet")}
      onActiveSheetChange={(sheet) =>
        setParams(
          (current) => {
            const next = new URLSearchParams(current);
            next.set("sheet", sheet);
            return next;
          },
          { replace: true },
        )
      }
    />
  );
};
